import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleAirport } from "./Constant/Source";
import SourceCreateForm from "./Forms/SourceCreateForm";

const AirportCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleAirport.create}>
      <SimpleForm>
        <SourceCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default AirportCreate;
